import { KaizenChartForHooks } from '@kaizenplatform/kaizen-chartjs';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Container, makeStyles, Typography } from '@material-ui/core';
import { GetChartFrequencyDocument, GetChartDocument, } from '../../../generated/graphql';
import { DateTime } from 'luxon';
import { useQuery, useLazyQuery } from '@apollo/client';
import { KeyboardDatePicker } from '@material-ui/pickers';
var useStyles = makeStyles({
    root: {
        marginTop: '24px',
    },
    periodContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    typography: {
        margin: '0px 10px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
});
var ChartContainer = function (_a) {
    var chartId = _a.chartId, initialChart = _a.initialChart;
    var classes = useStyles();
    var _b = useState(), chartVariables = _b[0], setChartVariables = _b[1];
    var _c = useState(DateTime.fromISO('2020-01-01')), from = _c[0], setFrom = _c[1];
    var _d = useState(DateTime.fromISO('2020-12-31')), to = _d[0], setTo = _d[1];
    var variablesForFrequency = {
        id: chartId,
        scope: { from: from, to: to },
    };
    var _e = useQuery(GetChartFrequencyDocument, {
        variables: variablesForFrequency,
        skip: [!chartId, initialChart].some(function (b) { return b; }),
    }), frequencyData = _e.data, frequencyLoading = _e.loading;
    var _f = useLazyQuery(GetChartDocument, {
        //variables: chartVariables,
        notifyOnNetworkStatusChange: true,
        context: { clientName: 'dataplatform' },
    }), getChart = _f[0], _g = _f[1], chartData = _g.data, chartLoading = _g.loading, refetchChart = _g.refetch;
    var initialFrequency = useMemo(function () {
        var _a, _b, _c;
        return initialChart && initialChart.frequencies
            ? initialChart.frequencies.includes('WEEKLY')
                ? 'WEEKLY'
                : initialChart.frequencies[0]
            : frequencyData && ((_a = frequencyData.chartId) === null || _a === void 0 ? void 0 : _a.frequencies)
                ? ((_b = frequencyData.chartId) === null || _b === void 0 ? void 0 : _b.frequencies.includes('WEEKLY')) ? 'WEEKLY'
                    : (_c = frequencyData.chartId) === null || _c === void 0 ? void 0 : _c.frequencies[0]
                : undefined;
    }, [chartId]);
    useEffect(function () {
        // 初期読み込み時の処理
        if (chartId) {
            var breakdowns = new Array();
            var variablesForChart = {
                id: chartId,
                scope: { from: from, to: to, frequency: initialFrequency },
                breakdowns: breakdowns,
            };
            setChartVariables(variablesForChart);
        }
    }, [frequencyData]);
    useEffect(function () {
        if (!initialChart)
            // lazyQuery requires variables to be wrapped by QueryLazyOptions
            getChart(chartVariables);
    }, [initialChart]);
    useEffect(function () {
        var scopeForChart = {
            from: from.toISO(),
            to: to.toISO(),
            frequency: chartVariables === null || chartVariables === void 0 ? void 0 : chartVariables.scope.frequency,
        };
        var variablesForChart = {
            id: chartId,
            scope: scopeForChart,
            breakdowns: chartVariables === null || chartVariables === void 0 ? void 0 : chartVariables.breakdowns,
        };
        setChartVariables(variablesForChart);
    }, [from, to]);
    var refetch = useCallback(function (id, from, to, frequency, breakdowns) {
        var variables = {
            id: id,
            scope: {
                from: from,
                to: to,
                frequency: frequency,
            },
            breakdowns: breakdowns,
        };
        chartData
            ? refetchChart(variables)
            : getChart({ variables: variables });
    }, [from, to, chartData]);
    var handleFromChange = function (date) {
        date && setFrom(date);
    };
    var handleToChange = function (date) {
        date && setTo(date);
    };
    return (React.createElement(Container, { className: classes.root },
        React.createElement("div", { className: classes.periodContainer },
            React.createElement(KeyboardDatePicker, { disableToolbar: true, variant: "inline", format: "yyyy/MM/dd", margin: "normal", id: "date-picker-inline", value: from, onChange: handleFromChange, KeyboardButtonProps: {
                    'aria-label': 'change date',
                }, maxDate: to }),
            React.createElement(Typography, { className: classes.typography }, "~"),
            React.createElement(KeyboardDatePicker, { disableToolbar: true, variant: "inline", format: "yyyy/MM/dd", margin: "normal", id: "date-picker-inline", value: to, onChange: handleToChange, KeyboardButtonProps: {
                    'aria-label': 'change date',
                }, minDate: from })),
        React.createElement(KaizenChartForHooks, { chartData: chartData ? chartData.chart : initialChart ? initialChart : undefined, chartId: chartId, from: from ? from.toISO() : DateTime.fromISO('2020-01-01').toISO(), to: to ? to.toISO() : DateTime.fromISO('2020-01-01').toISO(), loading: frequencyLoading || chartLoading, refetch: refetch, frequencies: chartData ? chartData.chart.frequencies : undefined, initialFrequency: initialFrequency, isDataplatform: true })));
};
export default ChartContainer;
